/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentGoCampaign_PrecinctGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Precinct Group API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Sunday, September 29, 2019 - 08:26:08 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/29/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const GoCampaign_PrecinctGroups = {
    all: (countryid, stateid) => requests.get(`/PrecinctGroups?countryid=${countryid}&stateid=${stateid}`),
    get: precinctgroupid => requests.get(`/PrecinctGroup/${precinctgroupid}`),
    create: precinctgroup => requests.post(`/PrecinctGroups`, precinctgroup),
    update: (precinctgroupid, precinctgroup) => requests.put(`/PrecinctGroup/${precinctgroupid}`, precinctgroup),
    delete: precinctgroupid => requests.del(`/PrecinctGroup/${precinctgroupid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentGoCampaign_PrecinctGroups.js